import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import type { HeadingSize } from '@/components/Heading/types'
import { safeCustomElement } from '@/utilities/custom-element'
@safeCustomElement('mdc-modal-header')
export class MdcModalHeader extends LitElement {
  @property({ type: String }) size: HeadingSize = 'lg'
  @property({ type: Boolean }) logo = false
  @property({ type: Boolean, attribute: 'show-back-button' }) showBackButton = false

  static styles = css`
		:host {
			display: block;
			font-family: var(--typography-font-family-sans);
		}
		.mdc-modal-header {
			display: flex;
			align-items: center;
			gap: var(--spacing-100, 1rem);
		}
		.mdc-modal-header--logo {
			justify-content: center;
		}
		.mdc-modal-header__heading {
			color: var(--color-functional-gray-black);
			font-weight: 600;
			line-height: 1.2;
			letter-spacing: -0.0175rem;
		}
		.mdc-modal-header__heading--size-lg { font-size: var(--text-175); }
		.mdc-modal-header__heading--size-md { font-size: var(--text-150); }
		.mdc-modal-header__heading--size-sm { font-size: var(--text-125); }
		.mdc-modal-header__heading--size-xs { font-size: var(--text-112-and-half); }
	`

  render() {
    if (this.logo) {
      return html`
				<div class="mdc-modal-header mdc-modal-header--logo">
					<mdc-brand-logo size="xs"></mdc-brand-logo>
				</div>
			`
    }

    return html`
			<div class="mdc-modal-header">
				${
          this.showBackButton
            ? html`
					<mdc-icon-button size="lg" iconSize="default" type="tertiary" icon="chevron-left"></mdc-icon-button>
				`
            : ''
        }
				<div class="mdc-modal-header__heading mdc-modal-header__heading--size-${this.size}">
					<slot></slot>
				</div>
			</div>
		`
  }
}
